import React from "react";

/**
 * One package OFFER, one card. (Not to be confused with `PackageCard.js`, which draws a package a
 * customer already owns as a membership-style card.)
 *
 * Extracted from the shop page (2026-11-03) so the shop's package section and the new shop packages
 * page (`/business/:businessSlug/:locationSlug/packages`) cannot drift apart. The card is a plain
 * click target: the parent decides what "select" means (both pages open the Buy package prompt,
 * exactly as the home page does).
 *
 * It deliberately does NOT open the item detail modal. That modal is a PRODUCT screen — it offers a
 * cart and "Add to Cart", and a package cannot be bought from a cart.
 */
const PackageOfferCard = ({ pkg, onSelect }) => {
  const hasSaving =
    pkg?.regularPrice && pkg?.packagePrice && pkg.regularPrice > pkg.packagePrice;

  const sessions =
    pkg?.totalSessions && typeof pkg.totalSessions === "object"
      ? pkg.totalSessions.value
      : pkg?.totalSessions;
  const validity = pkg?.validityPeriod
    ? typeof pkg.validityPeriod === "object"
      ? `${pkg.validityPeriod.value} ${pkg.validityPeriod.unit}`
      : `${pkg.validityPeriod} days`
    : null;

  return (
    <button
      type="button"
      onClick={() => onSelect?.(pkg)}
      style={{
        width: "100%",
        height: "100%",
        background: "white",
        borderRadius: 12,
        padding: 12,
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        transition: "transform 0.2s, box-shadow 0.2s",
        cursor: "pointer",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        border: "1px solid #e5e7eb",
        textAlign: "left",
        font: "inherit",
        color: "inherit",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = "0 12px 32px rgba(0,0,0,0.12)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
      }}
    >
      {hasSaving && (
        <span
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
            color: "white",
            padding: "4px 8px",
            borderRadius: 12,
            fontSize: 11,
            fontWeight: 700,
            boxShadow: "0 2px 8px rgba(239, 68, 68, 0.3)",
          }}
        >
          {Math.round((1 - pkg.packagePrice / pkg.regularPrice) * 100)}% OFF
        </span>
      )}

      <span
        style={{
          display: "block",
          fontSize: 14,
          fontWeight: 600,
          margin: "0 0 4px",
          color: "#111827",
          paddingRight: 60,
          lineHeight: 1.3,
        }}
      >
        {pkg?.name}
      </span>

      {pkg?.description && (
        <span
          style={{
            display: "-webkit-box",
            fontSize: 11,
            color: "#6b7280",
            margin: "0 0 6px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            lineHeight: 1.4,
          }}
        >
          {pkg.description}
        </span>
      )}

      {(sessions || validity) && (
        <span
          style={{
            display: "block",
            background: "#f0f9ff",
            padding: 8,
            borderRadius: 6,
            marginBottom: 8,
            border: "1px solid #bfdbfe",
            fontSize: 11,
            color: "#374151",
            lineHeight: 1.5,
          }}
        >
          {sessions ? <span style={{ display: "block" }}>✓ {sessions} sessions included</span> : null}
          {validity ? <span style={{ display: "block" }}>✓ Valid for {validity}</span> : null}
        </span>
      )}

      <span style={{ display: "block", marginTop: "auto" }}>
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 6,
            gap: 8,
          }}
        >
          <span>
            <span
              style={{
                display: "block",
                fontWeight: 700,
                color: "#1a659e",
                fontSize: 14,
              }}
            >
              ${Number(pkg?.packagePrice || 0).toFixed(2)}
            </span>
            {hasSaving && (
              <span
                style={{
                  display: "block",
                  fontSize: 12,
                  color: "#9ca3af",
                  textDecoration: "line-through",
                }}
              >
                ${Number(pkg.regularPrice || 0).toFixed(2)}
              </span>
            )}
          </span>

          {hasSaving && (
            <span style={{ fontSize: 12, fontWeight: 600, color: "#059669" }}>
              Save ${(pkg.regularPrice - pkg.packagePrice).toFixed(2)}
            </span>
          )}
        </span>

        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            padding: 6,
            background: "linear-gradient(135deg, #1a659e 0%, #004e89 100%)",
            color: "white",
            borderRadius: 8,
            fontWeight: 600,
            boxSizing: "border-box",
            fontSize: 13,
            whiteSpace: "nowrap",
          }}
        >
          Book Package →
        </span>
      </span>
    </button>
  );
};

export default PackageOfferCard;
